



















import { Component, Prop, Vue } from "vue-property-decorator";

import MessagePanel from "@/components/MessagePanel.vue";

@Component({ components: { MessagePanel } })
export default class TemplateFlowBanner extends Vue {
  @Prop({ default: false }) readonly editing!: boolean;
  @Prop({ default: false }) readonly creating!: boolean;
  @Prop({ default: "" }) readonly templateLabel!: string;
  @Prop({ default: "" }) readonly periodNote!: string;
  @Prop({ default: false }) readonly withPeriodNote!: boolean;
}
